import { IWithdrawalLimits } from '../../UserStatuses.t';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { UserStatusWithdrawalLimitsNumbersStyled } from './styled/UserStatusWithdrawalLimitsNumbersStyled';

interface IUserStatusWithdrawalLimitsNumbersProps {
    className?: string,
    withdrawalLimits?: IWithdrawalLimits
}

function UserStatusWithdrawalLimitsNumbers(props: IUserStatusWithdrawalLimitsNumbersProps) {
    const { className, withdrawalLimits } = props;
    const { getLangPath } = useLangContext();
    const dailyLimitUsd = withdrawalLimits?.dailyLimitUsd;
    const monthlyLimitUsd = withdrawalLimits?.monthlyLimitUsd;

    return <UserStatusWithdrawalLimitsNumbersStyled className={className}>
        {!!dailyLimitUsd &&
            <span
                dangerouslySetInnerHTML={{ __html: getLangPath('user_statuses.withdrawal_limits.daily_limit', { amount: `$${dailyLimitUsd}` }) }}/>}
        {!!monthlyLimitUsd &&
            <span
                dangerouslySetInnerHTML={{ __html: getLangPath('user_statuses.withdrawal_limits.monthly_limit', { amount: `$${monthlyLimitUsd}` }) }}/>}
        {!withdrawalLimits &&
            <span className={'unlimited-amount'}>{getLangPath('user_statuses.withdrawal_limits.unlimited')}</span>
        }
    </UserStatusWithdrawalLimitsNumbersStyled>;
}

export default UserStatusWithdrawalLimitsNumbers;
